import { AnimatedSection, NoiseTexture } from "./shared";
import Faqpage from "./FaqPage/Faqpage";

export default function LandingFAQSection() {
  return (
    <section id="faq" className="py-12 md:py-16 px-6 relative overflow-hidden">
      <NoiseTexture />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#0c0c0c] to-[#0a0a0a]" />

      <div className="max-w-4xl mx-auto relative z-10">
        <AnimatedSection>
          <div className="mb-12 text-center">
            <span className="inline-flex items-center gap-2.5 text-[11px] font-semibold tracking-[0.2em] uppercase text-white/35 mb-5 before:content-[''] before:w-5 before:h-px before:bg-gradient-to-r before:from-violet-500/60 before:to-transparent">
              Got questions? We have answers
            </span>
            <h2 className="font-space-grotesk text-4xl md:text-6xl font-bold tracking-[-0.03em] gradient-text-bright">
              FAQ
            </h2>
          </div>
        </AnimatedSection>

        <Faqpage />
      </div>
    </section>
  );
}
